import React from "react";
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <div>
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light header-nav">
          <a className='logoa' href="">
            <img src="/images/logo.png" alt="" className='logo' />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item active">
                {/* <Link className="nav-link" to="https://www.letsendorse.com">
                  PROJECTS <span className="sr-only">(current)</span>
                </Link> */}
                <a className='nav-link' href="https://www.letsendorse.com">Go to LetsEndorse</a>
              </li>
              {/* <li class="nav-item">
                <a class="nav-link" href="#">
                  Projects
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">
                  Legacy Chapters
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">
                  Login
                </a>
              </li>
              <li class="nav-item">
                <button type="button" className="nav-button">
                  Build your Legacy
                </button>
              </li> */}
            </ul>
          </div>
        </nav>
      </div>


      <div className="container-fluid header-container">
        <div className="row header-row">
          <h1 className="header-heading">LEGACY</h1>
          <p className="header-p1">
            When small, yet formidable pockets of people- power boosts
            locally-led lasting solutions,{" "}
            <span className="highlight">LEGACY</span> is formed.
          </p>
          <p className="header-p2">
            <span className="highlight">LEGACY</span>, an initiative of{" "}
            <span className="highlight">LetsEndorse</span>, has been created
            after several rounds of deliberation with philanthropists and aims
            to catalyze lasting and transformative change, working with
            thousands of dedicated non-profits, social innovators and
            change-enablers, like you!
          </p>
          <div className="header-button-container">
            <button type="button" className="header-button">
              <a href="#signup" className="button-a">
                Build your Legacy
              </a>
            </button>
            <div className="header-socio-handles">
              <a href="https://www.facebook.com/letsendorse"><i className="fab fa-facebook-f  header-socio-handle" /></a>
              <a href="https://twitter.com/letsendorse"><i className="fab fa-twitter header-socio-handle" /></a>
              <a href="https://www.linkedin.com/company/letsendorse/"><i className="fab fa-linkedin-in header-socio-handle" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/Components/LandingPage/Header.js